import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const UserRoundMinus: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M2 21a8 8 0 0 1 13.292-6' }],
    ['circle', { cx: '10', cy: '8', r: '5' }],
    ['path', { d: 'M22 19h-6' }],
  ],
];

export default UserRoundMinus;
